export const CART_ENSURE_SESSION = 'cart/CART_ENSURE_SESSION';
export const CART_OPEN_DRAWER = 'cart/CART_OPEN_DRAWER';
export const CART_CLOSE_DRAWER = 'cart/CART_CLOSE_DRAWER';
export const CART_ADD_LINE = 'cart/CART_ADD_LINE';
export const CART_REMOVE_LINE_AT_INDEX = 'cart/CART_REMOVE_LINE_AT_INDEX';
export const CART_SET_LINE_QTY_AT_INDEX = 'cart/CART_SET_LINE_QTY_AT_INDEX';
export const CART_CLEAR = 'cart/CART_CLEAR';
